import { Box } from '@mui/material';
import Decimal from 'decimal.js';
import { useAuth } from 'src/AuthProvider';
import UserTokensGraph from 'src/Components/UserTokensGraph';
import { styleGrid, styleHeader, styleHeaderExtra, stylePanelChartContainer } from 'src/styles/GridBox';
import apis from 'src/utils/apis';
import { format } from 'src/utils/numbers';
import { GridComponentParams } from '.';
import DragGrabber from './DragGrabber';
import { withGraphPosition } from './GraphPositionProvider';

const UserTokensGraphWithGraphPosition = withGraphPosition(UserTokensGraph);

function DV01Graph({market,token}:GridComponentParams){
  const auth = useAuth();
  const tokenId = token?.tokenId;
  const {data:userMarketData} = apis.rate.useUserMarketDataByToken(auth,{tokenId});
  let userPv01;
  if(userMarketData){
    userPv01 = new Decimal(userMarketData?.summary?.dv01||0);
  }
  return (
    <Box sx={styleGrid}>
      <Box sx={styleHeader}>PV01
        {userPv01&&<>:<Box component="span" sx={styleHeaderExtra}>{format(userPv01)}</Box></>}
      <DragGrabber/></Box>
      <Box sx={stylePanelChartContainer}>
        <UserTokensGraphWithGraphPosition token={token} graphKey='dv01' singleTokenGraph/>
      </Box>
    </Box>
  );
}


export default DV01Graph;